import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEventListener } from '@beef/react';
import { useFlag } from '@carnica/utils/hooks';
import { extractId, findAncestorWithTagName } from "./utils";
export var usePopupLinkListener = function usePopupLinkListener(popupId, defaultOpen) {
  var _useFlag = useFlag(defaultOpen),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOpen = _useFlag2[0],
    setIsOpen = _useFlag2[1];
  useEventListener('click', function (event) {
    var anchor = findAncestorWithTagName(event.target, 'A');
    if (!anchor) return;
    var href = anchor.getAttribute('href');
    var targetPopupId = extractId(href, /^#popup:(.*)$/i);
    if (!targetPopupId) return;
    event.preventDefault();
    if (popupId.toLowerCase() === targetPopupId.toLowerCase()) setIsOpen.on();
  }, typeof document !== 'undefined' && popupId ? document.body : undefined);
  return [isOpen, setIsOpen];
};